import { Box } from "@mui/material";
import {
    useCallback,
    useMemo,
    useState,
    useLayoutEffect,
    useEffect,
} from "react";
import cn from "classnames";
import { observer } from "mobx-react";
import _get from "lodash/get";
import { errorService } from "src/service/services";
import { useHistory } from "react-router-dom";

import { useLocale } from "src/providers/LocaleProvider";
import useStores from "src/hooks/useStores";
import { usePlayer } from "src/sounds/use-player";

import { IGame, EGameChatTab, UserBalanceType } from "src/store/models";
import { getButtonColor } from "src/helpers";
import useChangeTheme from "src/hooks/useChangeTheme";

import { emitter } from "src/shared/emitter";
import { ICreateGameRequestNew } from "src/service/api/lobby/requestResponses";

import { LocaleHelper } from "src/shared/helpers/LocaleHelper";
import { EColor } from "src/components/types";
import { useStyles } from "../styles";
import CreateGameBlockMobile from "./CreateGameBlockMobile";
import StopGameBlockMobile from "./StopGameBlockMobile";
import ReturnToGameBlockMobile from "./ReturnToGameBlockMobile";
import { GameInviteFilters } from "../../../GameFilter";

// ✅ Добавить интерфейс с пропсами для фильтров
interface ILobbyActionMobileProps {
    filters?: GameInviteFilters;
    onApplyFilter?: (filters: GameInviteFilters) => void;
    onResetFilter?: () => void;
}

const LobbyActionMobile = ({
    filters,
    onApplyFilter,
    onResetFilter
}: ILobbyActionMobileProps) => {
    const history = useHistory();
    const { authStore, lobbyStore } = useStores();

    const styles = useStyles();
    const user = authStore.currentUser;

    const mobileFilterFriends = lobbyStore.mobileNewGameHandler;

    const activeLobbyGames = lobbyStore.getActiveGamesDot();
    // Все игры в статусе создано
    const allLobbyInviteGames = lobbyStore.allLobbyInviteGames;
    // Все Запущенные игры
    const allLobbyParticipatingGames = lobbyStore.allLobbyParticipatingGames;
    // Все мои Запущенные игры
    const allLobbyGames = lobbyStore.allLobbyGames;
    // Все предложения поиграть - модалки
    const allInvitesAccepts = lobbyStore.allInvitesAccepts;

    const [isClicking, setIsClicking] = useState<boolean>(false);

    const locales = useLocale();
    const player = usePlayer();
    const appearanceTheme = useChangeTheme();
    const {
        lobby: {
            createGame: {
                buttons: { create, match },
            },
        },
    } = useLocale();

    const returnToGame = useCallback(() => {
        if (activeLobbyGames[0]) {
            return history.push(`game/${activeLobbyGames[0]._id}`);
        }
    }, [activeLobbyGames.length]);

    const myInviteGames = useMemo(() => {
        if (allLobbyInviteGames) {
            const dataInv = [...allLobbyInviteGames].filter((invite) => {
                return invite?.from._id === user?._id;
            });
            return dataInv;
        }
        return null;
    }, [allLobbyInviteGames]);

    const handleCancelClick = useCallback(() => {
        if (!isClicking && myInviteGames && myInviteGames[0]?._id) {
            setIsClicking(true);
            lobbyStore
                .cancelNormalInvite(myInviteGames[0]?._id)
                .finally(() => setIsClicking(false));
        }
    }, [isClicking, activeLobbyGames]);

    useEffect(() => {
        if (myInviteGames?.length === 4) {
            lobbyStore.showOnlyCreateGameBlock(false);
        }

    }, [myInviteGames]);

    const createBtnDisabled = !!(
        myInviteGames &&
        allLobbyParticipatingGames &&
        myInviteGames?.length + allLobbyParticipatingGames.length >= 4
    );

    const ActionComponent = useMemo((): JSX.Element => {
        if (!!myInviteGames && myInviteGames?.length >= 4) {
            return <StopGameBlockMobile stopSearching={handleCancelClick} />;
        }
        if (
            !!allLobbyParticipatingGames &&
            allLobbyParticipatingGames.length > 0 &&
            !mobileFilterFriends
        ) {
            return <ReturnToGameBlockMobile returnToGame={returnToGame} />;
        }
        return (
            <CreateGameBlockMobile
                myGameCount={allLobbyParticipatingGames.length}
                createBtnDisabled={createBtnDisabled}
                filters={filters}
                onApplyFilter={onApplyFilter}
                onResetFilter={onResetFilter}
            />
        );
    }, [
        activeLobbyGames,
        myInviteGames,
        returnToGame,
        allLobbyParticipatingGames,
        mobileFilterFriends,
        filters,
        onApplyFilter,
        onResetFilter,
    ]);

    return (
        <Box
            component="div"
            className={cn(styles.lobbyMobileActionContainer, appearanceTheme)}
        >
            {ActionComponent}
        </Box>
    );
};

export default observer(LobbyActionMobile);
